import { clientLocaleCookieName, defaultLocale, languageCookieName } from '@/src/lib/dictionary/settings';
import { ReadonlyHeaders } from 'next/dist/server/web/spec-extension/adapters/headers';
import Cookies from 'js-cookie';
import { Dictionary } from '@/src/lib/dictionary/types';
import { getTenantConfigValue } from '@/src/lib/store/business/get-tenants-config-value';

export function getLanguageFromHeaderCookie(headers: ReadonlyHeaders) {
  const languageCookie = headers
    .get('set-cookie')
    ?.split(', ')
    .find((cookie) => cookie.indexOf(`${languageCookieName}=`) !== -1);

  return (
    languageCookie
      ?.split('; ')
      .find((lang) => lang.startsWith(`${languageCookieName}=`))
      ?.replace(`${languageCookieName}=`, '') || defaultLocale
  );
}

export function getClientLocaleFromTheBrowser(): string | undefined {
  if (typeof window === 'undefined' || !navigator) {
    return undefined;
  }

  return navigator.language;
}

export function getClientLocaleFromClientCookie(): string | undefined {
  return Cookies.get(clientLocaleCookieName);
}

export function setClientLocaleCookie(lang: string): void {
  Cookies.set(languageCookieName, lang, { path: '/', sameSite: 'lax' });
}

export function getLocalizedItemsCount(count: number, dict: Dictionary) {
  return `${count} ${count === 1 ? dict.general.item : dict.general.items}`;
}

export function getMaxLengthMessage(fieldName: string, maxLength: number, dict: Dictionary) {
  return dict.messages.form.validation.maxLength
    .replace('%fieldName', fieldName)
    .replace('%maxLength', maxLength.toString(10));
}

export function getZipCodeMessage(dict: Dictionary, zipCode: string) {
  return dict.messages.form.validation.zipCode.replace('%s', zipCode);
}

export function getDialectForLocale(locale: string): string {
  const localeMap = getTenantConfigValue('localeMap') as Record<string, string>;
  return localeMap?.[locale] || locale;
}
